import { observable } from "mobx";
import Entity from "./Entity";

abstract class Store<E extends Entity<T>, T> {
  @observable protected entities: { [key: string]: E } = {};
}

export default Store;
